module.exports = __webpack_public_path__ + "img/1494376164.90822275.jpg";